import * as types from './mutation-types'

export default {
  [types.SET_INTEGRATIONS] (state, payload) {
    state.integrations = payload
  },
  [types.SET_INTEGRATION] (state, payload) {
    state.integration = payload
  },
  [types.SET_PROVIDERS] (state, payload) {
    state.providers = payload
  },
  [types.SET_AVAILABLE_FIELDS] (state, payload) {
    state.availableFields = payload
  },
  [types.SET_SYNC_LOGS] (state, payload) {
    state.syncLogs = payload
  }
}
